export function sortByObjectProperty(a, b, prop) {
    if (a[prop] > b[prop]) {
        return 1;
    }
    else if (a[prop] < b[prop]) {
        return -1;
    }
    else {
        return 0;
    }
}
